<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main style="padding-top:0rem;">
      <div class="zj-layout-main-content scrollable">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem" style="width: 118rem;">
        <el-form-item label="编制单位">
          <el-input v-model="ruleForm.OrgName" style="width:98rem;" v-bind:disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="预案名称" prop="PlanName">
          <el-input v-model="ruleForm.PlanName" style="width:98rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="预案编号" style="display:inline-block;" prop="PlanNo">
          <el-input v-model="ruleForm.PlanNo" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="预案版本号" style="display:inline-block;" prop="PlanVersion">
          <el-input v-model="ruleForm.PlanVersion" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="预案应对等级" style="display:inline-block;" prop="PlanLevel">
          <el-select
            v-model="ruleForm.PlanLevel"
            placeholder="请选择预案应对等级"
            v-bind:disabled="IsEdit"
            style="width:40rem;"
          >
            <el-option
              v-for="item in eventplanlevels"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预案属性" style="display:inline-block;" prop="PlanAttr">
          <el-select
            v-model="ruleForm.PlanAttr"
            style="width:40rem;"
            placeholder="请选择预案属性"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in planattrs"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预案类型" style="display:inline-block;" prop="PlanType">
          <el-select
            v-model="ruleForm.PlanType"
            style="width:40rem;"
            placeholder="请选择预案类型"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in plantypes"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否备案" style="display:inline-block;" prop="IsFiling">
          <el-select
            v-model="ruleForm.IsFiling"
            style="width:40rem;"
            placeholder="请选择是否备案"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in yesno"
              :key="item.Extend2"
              :label="item.Extend1"
              :value="item.Extend2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用事件类型" style="display:inline-block;" prop="FitEventType">
          <el-select
            style="width:40rem;"
            v-model="ruleForm.FitEventType"
            placeholder="请选择预案类型"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in fitEventTypes"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预案备案编号" style="display:inline-block;" prop="FilingNo">
          <el-input
            v-model="ruleForm.FilingNo"
            style="width:40rem;"
            maxlength="50"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布日期" style="display:inline-block;" prop="PublishDate">
          <el-date-picker
            type="date"
            style="width:40rem;"
            placeholder="选择日期"
            v-model="ruleForm.PublishDate"
            v-bind:disabled="IsEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预案备案时间" style="display:inline-block;" prop="FilingDate">
          <el-date-picker
            placeholder="选择日期"
            style="width:40rem;"
            v-model="ruleForm.FilingDate"
            v-bind:disabled="IsEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="制定人" style="display:inline-block;" prop="ProducerName">
          <el-input
            v-model="ruleForm.ProducerName"
            style="width:40rem;"
            maxlength="50"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
        <el-form-item label="预案状态" style="display:inline-block;" prop="PlanState">
          <el-select
            style="width:40rem;"
            v-model="ruleForm.PlanState"
            placeholder="请选择预案状态"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in planstatuses"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用范围描述" prop="PlanDesc">
          <el-input
            type="textarea"
            style="width:98rem;"
            v-model="ruleForm.PlanDesc"
            maxlength="1000"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
      </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer style="padding-bottom: 0rem;">
      <div style="text-align:center;width:134rem;padding:0rem 0rem;">
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">提交</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjPlanDetail",
  controller: "UI",
  action: "PlanDetail",
  props: {
    query: {
      type: String,
      obj: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      ruleForm: {
        OrgId: "",
        OrgName: "",
        PlanId: "",
        PlanName: "",
        PlanNo: "",
        PlanVersion: "",
        PlanLevel: null,
        PlanAttr: null,
        PlanType: null,
        IsFiling: null,
        FitEventType: null,
        FilingNo: "",
        PublishDate: "",
        FilingDate: "",
        ProducerName: "",
        ProducerId: "",
        PlanState: null,
        PlanDesc: "",
        Creater: "",
        Modifier: ""
      },
      plantypes: [],
      fitEventTypes: [],
      eventplanlevels: [],
      planstatuses: [],
      planattrs: [],
      yesno: [],
      rules: {
        PlanName: [
          { required: true, message: "请输入预案名称", trigger: "blur" },
          { min: 1, max: 200, message: "最多输入200个字符", trigger: "blur" }
        ],
        PlanNo: [
          { required: true, message: "请输入预案编号", trigger: "blur" },
          { min: 1, max: 50, message: "最多输入50个字符", trigger: "blur" }
        ],
        PlanVersion: [
          { required: true, message: "请输入预案版本号", trigger: "blur" },
          { min: 1, max: 30, message: "最多输入30个字符", trigger: "blur" }
        ],
        PlanLevel: [
          { required: true, message: "请选择预案级别", trigger: "change" }
        ],
        PlanAttr: [
          { required: true, message: "请选择预案属性", trigger: "change" }
        ],
        PlanType: [
          { required: true, message: "请选择预案类型", trigger: "change" }
        ],
        FitEventType: [
          { required: true, message: "请选择适用事件类型", trigger: "change" }
        ],
        PlanState: [
          { required: true, message: "请选择预案状态", trigger: "change" }
        ],
        PublishDate: [
          {
            //type: "date",
            required: true,
            message: "请选择发布日期",
            trigger: "change"
          }
        ],
        FilingDate: [
          {
            //type: "date",
            required: true,
            message: "请选择预案备案时间",
            trigger: "change"
          }
        ],
        IsEdit: false
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          OrgId: "",
          OrgName: "",
          PlanId: "",
          PlanName: "",
          PlanNo: "",
          PlanVersion: "",
          PlanLevel: null,
          PlanAttr: null,
          PlanType: null,
          IsFiling: null,
          FitEventType: null,
          FilingNo: "",
          PublishDate: "",
          FilingDate: "",
          ProducerName: "",
          ProducerId: "",
          PlanState: null,
          PlanDesc: "",
          Creater: "",
          Modifier: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';

      if (this.user.Departments != null && this.user.Departments.length > 0) {
        var dept = this.user.Departments[0];
        this.ruleForm.OrgId = dept.OrgId; //this.user.OrgId;
        this.ruleForm.OrgName = dept.OrgName;
      }

      this.ruleForm.ProducerId = this.user.UserId;
      this.ruleForm.ProducerName = this.user.UserName;
      this.ruleForm.Creater = this.user.UserId;
      this.ruleForm.Modifier = this.user.UserId;

      return utils.waitAll([
        this.config.getUValue("EmergencyService:EmergencyPlanType:", ""),  //预案类型
        this.config.getUValue("EmergencyService:FitEventType:", ""),       //适用事件类型
        this.config.getUValue("EmergencyService:EventPlanLevel:", ""),     //应对等级
        this.config.getUValue("EmergencyService:EmergencyPlanStatus:", ""),//预案状态
        this.config.getUValue("EmergencyService:EmergencyPlanAttr:", ""),
        this.config.getUValue("EmergencyService:EmergencyYesNo:", "")
      ])
      .then(r => {

        this.plantypes = r[0].JValue;
        this.fitEventTypes = r[1].JValue;
        this.eventplanlevels = r[2].JValue;
        this.planstatuses = r[3].JValue;
        this.planattrs = r[4].JValue;
        this.yesno = r[5].JValue;
        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    },
    search() {
      let PlanId = this.query.obj;
      if (PlanId != null && PlanId != "") {
        let searchInfo = {
          PlanId: PlanId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        this.loading = true;
        this.loadingText = '加载中...';
        new MyApis.PlanApi()
          .GetItemById(searchInfo)
          .then(r => {
            var data = r.data.Data;
            if (data) {
              this.ruleForm = data;
              if (
                this.user.Departments != null &&
                this.user.Departments.length > 0
              ) {
                var dept = this.user.Departments[0];
                this.ruleForm.OrgId = dept.OrgId; //this.user.OrgId;
                this.ruleForm.OrgName = dept.OrgName;
              }
            }
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.query.obj == null || this.query.obj == "") {
            this.loading = true;
            this.loadingText = '保存中...';
            new MyApis.PlanApi()
              .AddItem(this.ruleForm)
              .then(r => {
                r = r.data.Data;              
                this.query.obj = this.ruleForm.PlanId;
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！"
                });
                this.loading = false;
                this.logInfo.ActionName = "应急预案添加";
                this.logInfo.LogMessage = r ? "应急预案添加成功" : "应急预案添加失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急预案制定详情页面";
                this.addOperationLog();
                this.$router.go(-1); //返回上一层
              })
              .catch(e => {
                console.error(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                this.loading = false;
              });
          } else {
            this.loading = true;
            this.loadingText = '保存中...';
            new MyApis.PlanApi()
              .UpdateItem(this.ruleForm)
              .then(r => {
                r = r.data.Data;
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！"
                });
                this.loading = false;
                this.logInfo.ActionName = "应急预案修改";
                this.logInfo.LogMessage = r ? "应急预案修改成功" : "应急预案修改失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急预案制定详情页面";
                this.addOperationLog();
                this.$emit("ChangeTab", "second");
              })
              .catch(e => {
                console.error(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                this.loading = false;
              });
          }
        } else {
          console.error("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>